import React from 'react';
import styled from 'styled-components';

import history from '../../history';

import Table from 'components/table';
import {TdCenter} from 'components/table/components';
import {LinkSmall} from 'components/buttons';
import {statuses} from './statuses';

const Thead = styled.thead`
  tr > th {
    color: #000 !important;
  }
`;

const DocumentsList = ({ documents }) => {
  const handleLinkClick = e => e.stopPropagation()

  return <Table hover>
    <Thead>
    <tr>
      <th>Номер документа</th>
      <th>Назва документа</th>
      <th style={{textAlign: "center"}}>Розсилка</th>
      <th>Стан</th>
    </tr>
    </Thead>
    <tbody>
    {documents.map((item, i) => (
      <tr key={i} onClick={(event) => {
        event.preventDefault();
        history.push(`/admin/documents/detail/${item.get('id')}`)}}>
        <td><span>Номер документа:</span>{item.get('number')}</td>
        <td><span>Назва документа:</span>{item.get('name')}</td>
        <TdCenter>
          <span>Розсилка:</span>
          {item.get('is_distribution') ? (
            <i className="fa fa-check-circle" aria-hidden="true"></i>
          ):(
            <i style={{color: "#d73925"}} className="fa fa-times-circle-o" aria-hidden="true"></i>
          )}
        </TdCenter>
        <td><span>Стан:</span>{statuses[item.get('current_status')]}</td>
        <td><LinkSmall to={`/admin/documents/detail/${item.get('id')}`} onClick={handleLinkClick}>Детальніше</LinkSmall></td>
      </tr>
    ))}
    </tbody>
  </Table>
}

export default DocumentsList;



// WEBPACK FOOTER //
// ./src/admin/documents/documents-list.js